import { Controller } from '@hotwired/stimulus'
// @ts-expect-error: @hotwired/turbo is not typed
import * as Turbo from '@hotwired/turbo'

// Connects to data-controller="medical-plans-filter"
export default class extends Controller {
  static targets = [
    'form',
    'checkbox',
  ]

  declare readonly formTarget: HTMLFormElement

  connect () {
    document.addEventListener('turbo:before-fetch-request', this.showLoading)
    document.addEventListener('turbo:before-fetch-response', this.hideLoading)
  }

  showLoading (): void {
    const plansContainer = document.getElementById('available_medical_plans_container')
    const loadingContainer = document.getElementById('loading_medical_plans_container')

    loadingContainer?.classList.remove('hidden')
    plansContainer?.classList.add('hidden')
  }

  hideLoading (): void {
    const plansContainer = document.getElementById('available_medical_plans_container')
    const loadingContainer = document.getElementById('loading_medical_plans_container')

    plansContainer?.classList.remove('hidden')
    loadingContainer?.classList.add('hidden')
  }

  disconnect (): void {
    document.removeEventListener('turbo:submit-start', this.showLoading)
    document.removeEventListener('turbo:submit-end', this.hideLoading)
  }

  toggle () {
    const filterParams = new URLSearchParams(window.location.search)

    document.querySelectorAll<HTMLInputElement>("input[type='checkbox']").forEach(cb => {
      if (cb.checked) {
        filterParams.set(cb.name, cb.value)
      } else {
        filterParams.delete(cb.name)
      }
    })

    filterParams.set('sort', (document.getElementById('sort') as HTMLSelectElement).value)

    const url = window.location.pathname + '?' + filterParams.toString()

    // replace the entire container so the plan count is also updated
    Turbo.visit(url, { action: 'replace', frame: 'available_medical_plans_container' })
  }
}
